var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustoms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0683594,
    y: 0.862183,
    width: 95.2396,
    height: 95.2396,
    rx: 20.3547,
    fill: "#5E1B0C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1106_10980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6719 60.3517C34.6719 52.1439 41.3256 45.4902 49.5333 45.4902H60.6228C68.8305 45.4902 75.4842 52.1439 75.4842 60.3517V74.4247C75.4842 76.4767 73.8208 78.1401 71.7688 78.1401H38.3872C36.3353 78.1401 34.6719 76.4767 34.6719 74.4247V60.3517Z",
    fill: "#F8F7F2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.0718,
    cy: 38.6499,
    rx: 12.2437,
    ry: 12.2437,
    fill: "#FE6533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1044 22.4082C61.7229 22.4082 67.2901 26.9095 68.9116 33.0178C69.438 35.001 67.7252 36.6925 65.6733 36.6925L44.5354 36.6925C42.4835 36.6925 40.7707 35.001 41.2972 33.0178C42.9186 26.9095 48.4858 22.4082 55.1044 22.4082Z",
    fill: "#F8F7F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.3535,
    y: 31.1348,
    width: 19.7446,
    height: 5.5539,
    rx: 2.77695,
    fill: "#F8F7F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.748,
    y: 55.8496,
    width: 37.1536,
    height: 22.2921,
    rx: 3.71536,
    fill: "#FE6533"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1106_10980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.4457,
    height: 59.4457,
    fill: "white",
    transform: "translate(17.8984 18.6963)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustoms);
export default __webpack_public_path__ + "static/media/Customs.9edbb19e07cd5a7ab96547c36dc4c4f3.svg";
export { ForwardRef as ReactComponent };